import React, { Fragment } from "react";

const Header = () => {
  return (
    <Fragment>
      <h1>Shop Floor Sales Demo</h1>
      <div style={{ padding: "24px 0" }}>
        <p>
          Use this page to create or reset a Shop Floor Sales Demo for the
          specified company.
        </p>
        <p>
          For instructions on how to use this page, please see
          <a href="https://docs.google.com/document/d/1Tn67pYRhw1MyXzJDKhTQy1mkhAXbjXnATpQPNxNQ_3g/edit#">
            {" "}
            this
          </a>{" "}
          document.
        </p>
        <p>
          Address any problems or questions to the{" "}
          <a href="https://nu.slack.com/archives/C01CGNW6T7W">
            #shop-floor-support
          </a>{" "}
          channel.
        </p>
        <p>
          <b>Important:</b> In Step 1 below, if you enter a Demo Company Name
          for an existing demo company then the existing demo will be reset and
          cleared. Any customizations that you may have made will be lost.
        </p>
      </div>
    </Fragment>
  );
};

export default Header;
